import { getBuilderConfigURL } from '../../../../common/utils/builder-config-url-util';
import { addCollectionFieldTrait, getTraitForItemIdField } from '../collectionForm/components';
import { processSteps } from '../collectionForm/utils';
import { getCollectionOptionsForSelect, getInstalledPlugins } from '../pluginComponentApi';

export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const {
    projectId,
    collections,
    token,
    version,
    bindCollectionOptions,
    snippetCollectionTraitOptions,
  } = opt;
  console.log('🚀 ~ file: collectionFormTraits.js:8 ~ opt:', opt);

  let { collection, session, sessionTenant } = bindCollectionOptions;
  if (!collection) {
    collection = snippetCollectionTraitOptions.collection;
  }
  let snippetType = '';
  if (snippetCollectionTraitOptions.collection) {
    snippetType =
      snippetCollectionTraitOptions.snippet && snippetCollectionTraitOptions.snippet.snippetType
        ? snippetCollectionTraitOptions.snippet.snippetType
        : '';
  }
  let { collectionId: pageCollectionId } = collection || '';
  console.log('🚀 ~ file: collectionFormTraits.js:23 ~ pageCollectionId:', pageCollectionId);
  const pageCollection = collections.find((coll) => coll.collectionName === pageCollectionId);
  const style = document.createElement('style');
  style.innerHTML = `
  .checkmark::after {
    left: 4px;
    top: 4px;
  }

  checkbox {
    all: unset;
  }

  select option:first-child {
    color: grey;
  }

  select.empty {
    color: grey;
  }

  select option[disabled]:first-child {
    display: none;
  }

  input[type=webconnect-text] {
    display: block;
  }

  input[type=webconnect-link] {
    display: block;
  }
  `;
  document.head.appendChild(style);

  const installedPlugins = projectId ? await getInstalledPlugins(projectId, version) : '';
  console.log('🚀 ~ file: collectionFormTraits.js:58 ~ installedPlugins:', installedPlugins);
  const multiTenantPlugin =
    installedPlugins && installedPlugins.find((plugin) => plugin.code === 'MULTI_TENANT_SAAS');
  const hasMultiTenantPlugin = !!multiTenantPlugin;
  console.log(
    '🚀 ~ file: collectionFormTraits.js:62 ~ hasMultiTenantPlugin:',
    hasMultiTenantPlugin,
  );
  const { setting: multiTenantSetting } = multiTenantPlugin || '';
  const { multiTenantCollection, userSettingsCollection } = multiTenantSetting || '';

  if (collections) {
    traitManager.addType('dynamic-form-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `    

    <div class="row settings--progress-bar">
      <div class="container">
        <div class="progress">
          <div class="progress-bar"></div>
        </div>
      </div>
    </div>
    <hr/>
    <div id="CCT" class="settings--progress">
      <div class="gjs-container cms-data-container">
        <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
          <div class="badge badge-default cms--progress--step-1">
            <i class="wb webconnect"></i>
            <span class="step--desc">Step 1: Select Collection</span>
          </div>
          <div class="cms-create-collection-container" style="flex-grow: 1">
            <div class="gjs-row" style="flex-direction: row-reverse;">
              <a href=${getBuilderConfigURL()}collections/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
                <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Collection
              </a>
            </div>
          </div>
        </div>
        <div class="gjs-row">
          <div class="gjs-label-wrp d-none">
            <div class="gjs-label select-cms-data-label" title="Collection">Collection</div>
          </div>
          <div id="select-cms-data-div" class="gjs-field-wrp gjs-field-wrp--select-cms-data">
            <div id="select-field-div" style="display: none" class="gjs-field">
              <select class="selectField form-control form-control-sm options-light">
              </select>
            </div>
          </div>
        </div>

        <div class="gjs-row mx-auto pb-1 pt-3">
          <div class="badge badge-default cms--progress--step-2" style="display: none">
            <i class="wb webconnect"></i>
            <span class="step--desc">Step 2: Select Validation (Optional)</span>
          </div>
        </div>
      </div>
    </div>
    `;
        const cmsDataContainer = el.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = el.querySelector('.cms-create-collection-container');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');

        const cmsProgressBarContainer = el.querySelector('.settings--progress-bar');
        const cmsProgressStep = el.querySelector('.settings--progress');

        selectField.innerHTML = '';
        let optionHtml = `<option value="">None</option>`;
        cmsCreateCollectionContainer.style.display = 'block';
        cmsDataContainer.style.display = 'block';
        selectFieldDiv.style.display = 'block';
        optionHtml = getCollectionOptionsForSelect(collections);
        selectField.innerHTML = optionHtml;
        processSteps(cmsProgressStep, false, cmsProgressBarContainer);
        return el;
      },
      onEvent({ elInput, component }) {
        console.log('🚀 ~ file: collectionFormTraits.js:110 ~ onEvent ~ component:', component);
        const componentMethod = component.get('method');
        console.log(
          '🚀 ~ file: collectionFormTraits.js:112 ~ onEvent ~ componentMethod:',
          componentMethod,
        );
        const select = elInput.querySelector('.selectField');
        const cmsProgressStepTwo = document.querySelector('.cms--progress--step-2');

        let collectionName;
        if (select.value) {
          collectionName = select.value;
          component.set('collectionName', collectionName);
          cmsProgressStepTwo.style.display = 'block';
        } else {
        }
      },
      async onUpdate({ elInput, component }) {
        const cmsDataContainer = elInput.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = elInput.querySelector(
          '.cms-create-collection-container',
        );
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectField = elInput.querySelector('.selectField');

        const collectionName = component.get('collectionName');
        const validationUuid = component.get('validationUuid');

        const componentMethod = component.get('method');
        const componentDataItemIdFrom = component.get('getDataItemIdFrom');
        const itemIdFieldTrait = component.getTrait('itemIdField');
        const attrs = component.getAttributes();

        if (componentMethod === 'PUT') {
          attrs['method'] = componentMethod;
          if (componentDataItemIdFrom) {
            attrs['getDataItemIdFrom'] = componentDataItemIdFrom;
          }
          if (!attrs['getDataItemIdFrom']) {
            attrs['getDataItemIdFrom'] = 'DEFAULT';
          }
          const itemIdFromValue = component.get('getDataItemIdFrom');
          if (!itemIdFromValue) {
            component.set('getDataItemIdFrom', 'DEFAULT');
          }
          const itemIdField = component.get('itemIdField');
          await getTraitForItemIdField(
            component,
            attrs,
            componentDataItemIdFrom,
            itemIdFieldTrait,
            collections,
            pageCollection,
            multiTenantCollection,
            userSettingsCollection,
            itemIdField,
            snippetType,
          );
          const createItemFormValue = attrs['createItem'];
          const dataItemIdFromValue = component.get('getDataItemIdFrom');
          const createItemFormValueTrait = component.getTrait('createItem');

          if (dataItemIdFromValue !== 'BROWSER_SESSION_STORAGE') {
            if (!createItemFormValueTrait) {
              if (itemIdField && itemIdField.includes('.')) {
                if (component.getTrait('createItem')) component.removeTrait('createItem');
                let value = createItemFormValue && createItemFormValue === 'true' ? true : false;
                component.addTrait(
                  {
                    type: 'checkbox',
                    label: "Create Item if doesn't Exist",
                    name: 'createItem',
                    value,
                    valueTrue: 'true',
                    valueFalse: 'false',
                  },
                  { at: component.getTraitIndex('itemIdField') + 1 },
                );
              }
            } else {
              if (itemIdField && !itemIdField.includes('.')) {
                if (component.getTrait('createItem')) component.removeTrait('createItem');
              }
            }
            component.setAttributes(attrs);
          }
          if (dataItemIdFromValue === 'ENTITY_COLLECTION') {
            const entityStorageKey = component.get('entityStorageKey');
            await addCollectionFieldTrait(
              component,
              collections,
              entityStorageKey,
              'entityStorageKey',
              itemIdFieldTrait,
              itemIdField,
            );
          } else {
            const entityStorageKeyTrait = component.getTrait('entityStorageKey');
            if (entityStorageKeyTrait) component.removeTrait('entityStorageKey');
            if (attrs['data-entity-key']) delete attrs['data-entity-key'];
            component.setAttributes(attrs);
          }
        } else {
          attrs['method'] = componentMethod;
          delete attrs['getDataItemIdFrom'];
          delete attrs['itemIdField'];
          delete attrs['createItem'];
          component.setAttributes(attrs);
        }

        const cmsProgressBarContainer = elInput.querySelector('.settings--progress-bar');
        const cmsProgressStep = elInput.querySelector('.settings--progress');
        const cmsProgressStepTwo = elInput.querySelector('.cms--progress--step-2');

        let optionHtml = `<option value="">- Select Collection -</option>`;
        selectFieldDiv.style.display = 'block';
        cmsDataContainer.style.display = 'block';
        cmsCreateCollectionContainer.style.display = 'block';
        optionHtml = getCollectionOptionsForSelect(collections);
        selectField.innerHTML = optionHtml;
        selectField.value = collectionName;

        if (collectionName || selectField.value) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          cmsProgressStepTwo.style.display = 'block';
          if (validationUuid) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
          }
        }
      },
    });
  } else {
    traitManager.addType('dynamic-form-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.innerHTML = ``;
        return el;
      },
    });
  }
}
